import React from "react";
import Register from "./Register";
import Pager from "components/Pager";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { withTranslation } from "react-i18next";

class UpdateOldAccount extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            idx:0,
        };
        this.close = this.close.bind(this);
    }
    go(idx){
        this.setState({idx});
    }
    close(){
        this.props.onClose();
        setTimeout(()=>this.setState({
            idx:0,
        }),500);
    }
    render() {
        const { t } = this.props;
        return (
            <Dialog open={this.props.open} scroll="body" className="my-dialog">
                <Pager pages={[
                    <>
                    <DialogContent>
                        {t('votre-compte-utilisateur-evolue-merci-de-saisir-un-mot-de-passe-pour-securiser-votre-profil')}
                    </DialogContent>
                    <DialogActions>
                        <Button variant='contained' color='primary' onClick={()=>this.go(1)}>{t('saisir-mon-mot-de-passe')}</Button>
                    </DialogActions>
                    </>
                    ,
                    <Register initEmail={this.props.appState.oldEmail} {...this.props}/>
                ]} idx={this.state.idx}/>
            </Dialog>
        );
    }
}

export default withTranslation()(UpdateOldAccount);
